import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { P } from '../../base/typography';
import { useTranslationsContext } from '../context/translationsContext';
import { FormStepHeading, FormStepWrapper, ProceedButton } from '../sendReceiptMultistep.styles';

export default function Received() {
	const translations = useTranslationsContext();
	const { t } = useTranslation('sendReceiptMultistep');
	const [isClosed, setIsClosed] = useState(false);

	if (isClosed) {
		return null;
	}

	return (
		<FormStepWrapper>
			<FormStepHeading>{translations?.received?.success || t('received.success')}</FormStepHeading>
			<P>{translations?.received?.successText || t('received.successText')}</P>
			<ProceedButton
				type="button"
				onClick={() => {
					setIsClosed(true);
					window.location.reload();
				}}>
				{translations?.close || t('close')}
			</ProceedButton>
		</FormStepWrapper>
	);
}
